import { React, Component, useState, useEffect, useRef, useContext } from "react"
import { createPortal } from 'react-dom'
import { gql } from '@apollo/client';
import { useQuery } from '@apollo/client/react';
import { _Q } from "../query/queries"
import { activateMenu, checkUpdateNeeded, c_Fn, setItemDB, getItemDB,uuidv4, getProjectKey } from "./commons";
import { ThemeContext } from "./theme-toggler/theme-context";
import { loadingProgress } from "./APPF_ICONS"
import useProjectStore from "../store/projectStore";
import useCoreStore from "../store/coreStore";
import { useEnsureHosts, useEnsureApplications, useEnsureInstalledPackages } from "../store/useCoreData";
import "./designer/Designer.css";
function createPortal1(children, mountNode) {
  let res = createPortal(children, mountNode)
  return res
}

export class IFrame extends Component {
  constructor(props) {
    super(props)
    this.state = {
      mountNode: null
    }
    this.setContentRef = (contentRef) => {
      this.setState({
        mountNode: contentRef?.contentWindow?.document?.body,
        cw: contentRef?.contentWindow
      })
    }
  }

  render() {
    const { children, ...props } = this.props
    const { mountNode } = this.state


    return (
      <iframe
        {...props}
        ref={this.setContentRef}
      >
        {mountNode && createPortal1(children, mountNode)}
      </iframe>
    )
  }
}

const SecurityBlast = (props) => {

  const currentProjectId = useProjectStore(s => s.currentProjectId);
  const isFirstRender = useRef(true);
  const [canShowData, setCanShowData] = useState(false)
  const [gotVersion, setGotVersion] = useState(false)
  const [iframeVersion, setIframeVersion] = useState(Date.now())

  useEffect(() => {
    getItemDB(getProjectKey("viewType")).then( data => {
      if(data == "vulnerabilityData") {
        setCanShowData(true)
    }
  })
  }, [])

  const { data: versionData, error: versionError, refetch: refetchVersion } = useQuery(gql`${_Q._Q_versionTime}`,
    {
      skip: props?.isInstalledSoftware,
      fetchPolicy: "network-only",
      errorPolicy: "all",
      notifyOnNetworkStatusChange: true
    });

  useEffect(() => {
    let isMounted = true;

    if (versionError) {
      console.error('SecurityBlast: Error fetching version data:', versionError);
      return;
    }

    if (versionData?.systems?.systems && versionData?.hosts?.hosts) {
      if (isMounted) {
        c_Fn.setVersionInfo({ systems: versionData.systems.systems, hosts: versionData.hosts.hosts });
        setGotVersion(true);
      }
    }

    return () => {
      isMounted = false;
    };
  }, [versionData, versionError]);

  const { data: vulnerabilityBlastData, refetch: refetchVulnerabilityBlast } = useQuery(gql`${_Q._Q_vulnerabilityBlast}`,
    {
      fetchPolicy: "network-only",
      notifyOnNetworkStatusChange: true,
      skip: !gotVersion
    });

  useEffect(() => {
    if (vulnerabilityBlastData) {
      setItemDB(getProjectKey("viewType"), "vulnerabilityData")
      // setItemDB("viewType", "hostData")
      let map = {};

      let res = { nodes: [], links: [] };
      let existingHosts = []

      vulnerabilityBlastData.vulnerabilities.forEach(item => {
        let finItem = {};

        if (map[item.vulnerability.cve]) {
          finItem = {
            id: item.vulnerability.cve + " - " + item.vulnerability.version,
            name: item.vulnerability.cve + " - " + item.vulnerability.version,
            description: item.vulnerability.description,
            group: "vulnerability",
            nodeColor: 123123,
            val: item.affectedHosts.length,
            data: {
              affectedHosts: item.affectedHosts,
              vulnerability: {
                ...item.vulnerability,
                cve: item.vulnerability.cve + " - " + item.vulnerability.version
              }

            }
          }

          res.nodes.push(finItem);
        } else {
          finItem = {
            id: item.vulnerability.cve,
            name: item.vulnerability.cve,
            description: item.vulnerability.description,
            group: "vulnerability",
            nodeColor: 123123,
            val: item.affectedHosts.length,
            data: item
          }
          res.nodes.push(finItem);
          map[item.vulnerability.cve] = true;
        }

        let linkCount = 0
        for (let hostId of finItem.data.affectedHosts.filter((v, i, a) => a.indexOf(v) === i)) {
          linkCount++
          if (!existingHosts.includes(hostId)) {
            existingHosts.push(hostId)
            res.nodes.push({
              id: hostId,
              name: window._g.timeMachine.find(host => host.id == hostId)?.name,
              group: "host"
            });
          }

          existingHosts.push(hostId)
          res.links.push({
            source: finItem.id,
            target: hostId,
          });

        }

      });

      let linksMap = {};

      res.links.map(l => {
        if (typeof linksMap[l.source + l.target] === 'undefined') {
          if (typeof linksMap[l.target + l.source] === 'undefined') {
            linksMap[l.source + l.target] = 1;
          } else {
            linksMap[l.target + l.source] += 1
          }
        } else {
          linksMap[l.source + l.target] += 1
        }
      })

      setItemDB(getProjectKey("vulnerabilityData"), res)
    }
  }, [vulnerabilityBlastData])

  useEnsureHosts();
  useEnsureApplications();
  useEnsureInstalledPackages();
  const storeHosts = useCoreStore(s => s.hosts);
  const storeApplications = useCoreStore(s => s.applications);
  const storeInstalledPackages = useCoreStore(s => s.installedPackagesAgg);

  useEffect(() => {
    if (!storeHosts.length) return;
    const hostsMap = {};

    storeHosts.forEach((host) => {
      hostsMap[host.machineId] = {
        name: host.name,
        machineId: host.machineId,
        timestamp: host.timestamp,
        tags: host.tags,
        os: host.os ? { name: host.os.name, eolDate: host.os.eolDate } : null,
        jvm: host.jvm ? { name: host.jvm.name, version: host.jvm.version, eolDate: host.jvm.eolDate } : null
      };
    });

    // Merge vulnerability data with severity counts from vulnerabilityBlastData
    if (vulnerabilityBlastData?.vulnerabilities) {
      vulnerabilityBlastData.vulnerabilities.forEach(item => {
        const severity = item.vulnerability.severity?.toUpperCase() || "UNKNOWN";

        item.affectedHosts.forEach(hostId => {
          if (hostsMap[hostId]) {
            if (!hostsMap[hostId].vulnerabilities) {
              hostsMap[hostId].vulnerabilities = { critical: 0, high: 0, medium: 0, low: 0, total: 0 };
            }

            hostsMap[hostId].vulnerabilities.total++;

            if (hostsMap[hostId].vulnerabilities[severity.toLowerCase()] !== undefined) {
              hostsMap[hostId].vulnerabilities[severity.toLowerCase()]++;
            }
          }
        });
      });
    }

    // Merge software/packages data
    storeInstalledPackages.forEach(h => {
      if (hostsMap[h.machineId]) {
        hostsMap[h.machineId].software = {
          totalInstalled: h.totalInstalled,
          eolPackages: h.eolPackages,
          candidatePackages: h.candidatePackages,
        };
      }
    });

    // Merge applications data
    storeApplications.forEach(app => {
      if (hostsMap[app.machineId]) {
        if (!hostsMap[app.machineId].applications) {
          hostsMap[app.machineId].applications = [];
        }
        hostsMap[app.machineId].applications.push({ name: app.name, version: app.version });
      }
    });

    setItemDB(getProjectKey("hostsDiscoveryMap"), hostsMap);

    // Notify the iframe about the update
    try {
      const iframe = document.querySelector('iframe');

      if (iframe?.contentWindow) {
        iframe.contentWindow.dispatchEvent(new CustomEvent('indexedDBUpdated', {
          detail: { key: getProjectKey("hostsDiscoveryMap"), value: hostsMap }
        }));
      }
    } catch (e) { /* cross-origin or iframe not ready */ }
  }, [storeHosts, storeInstalledPackages, storeApplications, vulnerabilityBlastData]);

  const { data: hostData, error: hostError, refetch: refetchHD } = useQuery(
    gql`${c_Fn.cleanUpQuery(_Q._Q_host).replaceAll(_Q._Q_qToken, props?.mid)
      .replaceAll(_Q._Q_qToken2, props.mid ? props.mid?.replaceAll("-", "_") : "")}`,
    {
      fetchPolicy: "cache-first",
      errorPolicy: "all",
      notifyOnNetworkStatusChange: true,
      skip: !props?.mid
    });

  useEffect(() => {
    let isMounted = true;

    if (hostError) {
      console.error('SecurityBlast: Error fetching host data:', hostError);
      return;
    }

    if (hostData) {
      const firstKey = Object.keys(hostData)[0];
      if (firstKey && isMounted) {
        // Data is fetched but not stored - only used for refetch
      }
    }

    return () => {
      isMounted = false;
    };
  }, [hostData, hostError]);

  const { data: systemData, error: systemError, refetch: refetchSD } = useQuery(
    gql`${c_Fn.cleanUpQuery(_Q._Q_system).replaceAll(_Q._Q_qToken, props?.mid)
      .replaceAll(_Q._Q_qToken2, props.mid ? props.mid?.replaceAll("-", "_") : "")}`,
    {
      fetchPolicy: "no-cache",
      errorPolicy: "all",
      notifyOnNetworkStatusChange: true,
      skip: !props?.mid
    });

  useEffect(() => {
    let isMounted = true;

    if (systemError) {
      console.error('SecurityBlast: Error fetching system data:', systemError);
      return;
    }

    if (systemData) {
      const firstKey = Object.keys(systemData)[0];
      if (firstKey && isMounted) {
        // Data is fetched but not stored - only used for refetch
      }
    }

    return () => {
      isMounted = false;
    };
  }, [systemData, systemError]);

  const iframeRef = useRef(null)
  useEffect(() => {
    checkUpdateNeeded("deploy", () => {
      refetchVersion();
      refetchSD()
      refetchHD()
      useCoreStore.getState().invalidate(['hosts', 'applications', 'installedPackages']);
      useCoreStore.getState().ensureHosts();
      useCoreStore.getState().ensureApplications();
      useCoreStore.getState().ensureInstalledPackages();
    })

    setTimeout(() => {
      iframeRef.current?.state?.cw.focus()
      iframeRef.current?.state?.cw.focus
    }, 200)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    activateMenu("security");
  }, []);

  // Refetch all data when the active project changes (skip initial mount)
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    const refetchAll = async () => {
      setCanShowData(false);
      setGotVersion(false);
      setID(uuidv4());
      setIframeVersion(Date.now());

      try {
        await refetchVersion();
        await refetchVulnerabilityBlast();
        // hosts/apps/packages are managed by coreStore — project switch triggers resetAll + fresh fetch
      } catch (e) {
        console.error("Error refetching data:", e);
      }
    };

    refetchAll();
  }, [currentProjectId, refetchVersion, refetchVulnerabilityBlast]);

  const { theme } = useContext(ThemeContext);

  const [dark, setDark] = useState(theme == "dark" ? true : false);
  const [id, setID] = useState("secframe");
  useEffect(() => {
    setID(uuidv4())
    setDark(theme == "dark" ? true : false)
  }, [theme]);


  const urlFor3d = `./3d/build/index.html`;
  return (<>
  {
  props.isInstalledSoftware?<>
  <div style={{
    width: "calc(100%)",
    height: props.isInstalledSoftware?"calc(100vh - 64px)":"100%" 
  }}
  >
  
    <IFrame
      key={id}
      ref={iframeRef}
      style={{
        marginLeft: 0,
        zIndex: 1000,
        background: dark ? "var(--background-gradient-main)" : "#FFFFFF",
      }}
      src={`${urlFor3d}?v=${iframeVersion}&installedSoftware=1`}
      width="100%" 
      height={"100%" }
      />
      </div>
      </>
      :
    (vulnerabilityBlastData != null || canShowData)? (<IFrame
      key={id}
      ref={iframeRef}
      style={{
        marginLeft: 0,
        zIndex: 1000,
        background: dark ? "var(--background-gradient-main)" : "#FFFFFF",
        border: "0px solid red",
        borderLeft: `${dark ? "1" : "0"}px solid rgba(255,255,255,0.081)`,
      }}
      src={`${urlFor3d}?v=${iframeVersion}`} width="100%" height="100%" />)
      : (
        <div
          style={{
            position: 'relative',
            borderLeft: `${dark ? "1" : "0"}px solid rgba(255,255,255,0.081)`,
            marginLeft: 40,
            width: '100%',
            minWidth: '650px',
            height: '100%',
            overflow: 'hidden',
          }}
        >
          <div
            className="dndflowloading"
            style={{
              zIndex: 99999,
              position: 'absolute',
              top: "calc(50% - 100px)",
              left: "calc(50% - 200px)",
              fontSize: 28,
              width: '200px',
              color: "#C02B11",
              height: '30px',
              // border: '1px solid red'
            }}
          >
            <div
              style={{
                position: 'absolute',
                fontSize: 28,
                marginTop: 22,
                marginLeft: 'calc(50% - 200px)',
                width: '400px',
                color: !dark ? "var(--background-gradient-main)" : "#FFFFFF55",
                height: '30px',
              }}
            >Loading data ...</div>
            {loadingProgress}
          </div></div>)}
  </>)
};

export default (props) =><SecurityBlast isInstalledSoftware={props.isInstalledSoftware} />;